import { Check, Close, CloseFullscreen, OpenInFullOutlined, Save, SearchOutlined, SettingsOutlined, ZoomIn, ZoomInOutlined, ZoomOutMapOutlined, ZoomOutOutlined } from '@mui/icons-material';
import { Button, CircularProgress, Divider, IconButton, InputAdornment, inputLabelClasses, Stack, TextField, Tooltip } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { RefObject, useCallback } from 'react';
import { useMediaPredicate } from 'react-media-hook';
import { GanttComponent, TimelineViewMode } from '@syncfusion/ej2-react-gantt';

export interface TodoGanttToolbarProps {
    gantt: RefObject<GanttComponent>;
}

export default function TodoGanttToolbar(props: TodoGanttToolbarProps) {
    const { gantt } = props;
    const { t } = useTranslation();
    const [searchText, setSearchText] = React.useState('');

    const biggerThan800 = useMediaPredicate("(min-width: 800px)");

    return (
        <div style={{ padding: '4px', border: '1px solid #cccccc', borderBottom: '0px', justifyContent: 'space-between', display: 'flex' }} >
            <Stack spacing={2} direction={'row'} alignItems='center' borderBottom={0}>
                <TextField label={t('SearchInTodo')}
                    InputLabelProps={{
                        sx: {
                            [`&.${inputLabelClasses.shrink}`]: {
                                // set the color of the label when shrinked (usually when the TextField is focused)
                                color: "gray",
                                marginTop: '2px',
                                fontSize: '13px'
                            }
                        }
                    }}

                    sx={{
                        border: '0px solid white',
                        ml: '16px',
                        minWidth: biggerThan800 ? '200px' : '100px',
                        backgroundColor: '#F9F9F9',
                        borderRadius: '16px',
                    }}
                    InputProps={{
                        endAdornment: <InputAdornment position='end'>
                            <SearchOutlined sx={{ fontSize: '12px' }} />
                        </InputAdornment>
                    }}
                    size='small'

                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            console.log('searching ...', searchText, gantt.current);
                            gantt.current?.search(searchText);
                        }
                    }}
                    value={searchText}
                    onChange={(e) => { setSearchText(e.target.value) }} />
                <Button onClick={(e) => {
                    gantt.current?.expandAll();
                }} startIcon={<OpenInFullOutlined />} variant='contained' size='small'>{biggerThan800 ? t('expandAll') : ''}</Button>
                <Button onClick={(e) => {
                    gantt.current?.collapseAll();
                }} startIcon={<CloseFullscreen />} variant='contained' size='small'>{biggerThan800 ? t('collapseAll') : ''}</Button>
            </Stack>

            <Stack direction='row' spacing={1} border={1} borderColor={'#cccccc'} borderRadius={2} pr={1} pl={1}>
                <IconButton onClick={(e) => {
                    console.log('zooming levels', gantt.current?.zoomingLevels, gantt.current?.currentZoomingLevel);
                    if (!gantt.current?.currentZoomingLevel.level || gantt.current?.currentZoomingLevel.level < 16)
                        gantt.current?.zoomIn();
                }} size='small'><ZoomInOutlined /></IconButton>
                <Divider orientation="vertical" flexItem sx={{ borderColor: '#cccccc' }} />
                <IconButton onClick={(e) => {
                    gantt.current?.zoomOut();
                }} size='small'><ZoomOutOutlined /></IconButton>
                <Divider orientation="vertical" flexItem sx={{ borderColor: '#cccccc' }} />
                <Tooltip title={t('gantt.adjustZoom')}>
                    <IconButton onClick={(e) => {
                        gantt.current?.fitToProject();
                    }} size='small'><ZoomOutMapOutlined /></IconButton>
                </Tooltip>
                <Divider orientation="vertical" flexItem sx={{ borderColor: '#cccccc' }} />
                <IconButton onClick={(e) => {
                    if (gantt.current) {
                        gantt.current.timelineSettings.timelineViewMode = 'Week' as TimelineViewMode;
                    }
                }} size='small'>{t('gantt.week')}</IconButton>
                <Divider orientation="vertical" flexItem sx={{ borderColor: '#cccccc' }} />
                <IconButton onClick={(e) => {
                    if (gantt.current) {
                        gantt.current.timelineSettings.timelineViewMode = 'Month' as TimelineViewMode;
                    }
                }} size='small'>{t('gantt.month')}</IconButton>
                <Divider orientation="vertical" flexItem sx={{ borderColor: '#cccccc' }} />
                <IconButton onClick={(e) => {
                    if (gantt.current) {
                        gantt.current.timelineSettings.timelineViewMode = 'Year' as TimelineViewMode;
                    }
                }} size='small'>{t('gantt.year')}</IconButton>
            </Stack>
        </div>
    );
}
